"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardsFilter = void 0;
const vue_1 = require("vue");
const AllCards_1 = require("../../cards/AllCards");
const TranslateMixin_1 = require("../TranslateMixin");
const allItems = AllCards_1.ALL_PROJECT_CARD_NAMES.concat(AllCards_1.ALL_PRELUDE_CARD_NAMES).concat(AllCards_1.ALL_LEADER_CARD_NAMES).sort();
exports.CardsFilter = vue_1.default.component('cards-filter', {
    props: {},
    data: function () {
        return {
            selectedCardNames: [],
            foundCardNames: [],
            searchTerm: '',
        };
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        isPrelude: function (cardName) {
            return AllCards_1.ALL_PRELUDE_CARD_NAMES.includes(cardName);
        },
        isLeader: function (cardName) {
            return AllCards_1.ALL_LEADER_CARD_NAMES.includes(cardName);
        },
        removeCard: function (cardNameToRemove) {
            this.selectedCardNames = this.selectedCardNames.filter((curCardName) => curCardName !== cardNameToRemove).sort();
        },
        addCard: function (cardNameToAdd) {
            if (this.selectedCardNames.includes(cardNameToAdd))
                return;
            this.selectedCardNames.push(cardNameToAdd);
            this.selectedCardNames.sort();
            this.searchTerm = '';
        },
    },
    watch: {
        selectedCardNames: function (value) {
            this.$emit('cards-list-changed', value);
        },
        searchTerm: function (value) {
            if (value === '') {
                this.foundCardNames = [];
                return;
            }
            if (value.indexOf(',') !== -1) {
                const cardNames = new Set(value.split(',').map((c) => c.trim()));
                for (const item of allItems) {
                    if (cardNames.has(item)) {
                        this.addCard(item);
                    }
                }
                return;
            }
            const newCardNames = allItems.filter((candidate) => !this.selectedCardNames.includes(candidate) && candidate.toLowerCase().indexOf(value.toLowerCase()) !== -1).sort();
            this.foundCardNames = newCardNames.slice(0, 5);
        },
    },
    template: `
    <div class="cards-filter">
        <h2 v-i18n>Cards to exclude from the game</h2>
        <div class="cards-filter-results-cont" v-if="selectedCardNames.length">
            <div class="cards-filter-result" v-for="cardName in selectedCardNames">
                <label>
                  {{ cardName }}
                  <i class="create-game-expansion-icon expansion-icon-prelude" title="This card is prelude" v-if="isPrelude(cardName)"></i>
                  <i class="create-game-expansion-icon expansion-icon-leaders" title="This card is CEO" v-if="isLeader(cardName)"></i>
                </label>
                <Button size="small" type="close" :onClick="_=>removeCard(cardName)" /> 
            </div>
        </div>
        <div class="cards-filter-input">
            <div>
                <input class="form-input" :placeholder="$t('Start typing the card name to exclude')" v-model="searchTerm" />
            </div>
            <div class="cards-filter-suggest" v-if="foundCardNames.length">
                <div class="cards-filter-suggest-item" v-for="cardName in foundCardNames">
                    <a href="#" v-on:click.prevent="addCard(cardName)">
                      {{ cardName }}
                      <i class="create-game-expansion-icon expansion-icon-prelude" title="This card is prelude" v-if="isPrelude(cardName)"></i>
                      <i class="create-game-expansion-icon expansion-icon-leaders" title="This card is CEO" v-if="isLeader(cardName)"></i>
                    </a> 
                </div>
            </div>
        </div>
    </div>
    `,
});
//# sourceMappingURL=CardsFilter.js.map